import { render, staticRenderFns } from "./UserPet.vue?vue&type=template&id=403fd58f&scoped=true&"
import script from "./UserPet.vue?vue&type=script&lang=js&"
export * from "./UserPet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403fd58f",
  null
  
)

export default component.exports